import { render, staticRenderFns } from "./Support1.vue?vue&type=template&id=6ebbcc1e&scoped=true"
import script from "./Support1.vue?vue&type=script&lang=js"
export * from "./Support1.vue?vue&type=script&lang=js"
import style0 from "./Support1.vue?vue&type=style&index=0&id=6ebbcc1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebbcc1e",
  null
  
)

export default component.exports